import {
  ActionIcon,
  Anchor,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Container,
  Flex,
  Modal,
  Table,
  NumberInput,
  Switch,
  Text,
  Tooltip,
  Group,
  Paper,
  TextInput,
} from "@mantine/core";
import dayjs from "dayjs";
import { useMediaQuery } from "@mantine/hooks";
import { openConfirmModal } from "@mantine/modals";
import {
  IconDownload,
  IconEdit,
  IconEye,
  IconPackage,
  IconPlus,
  IconPrinter,
  IconRefreshDot,
  IconTrash,
  IconArrowRight,
} from "@tabler/icons";
import FloatingMenu from "components/FloatingMenu";
import { PrintModal } from "components/PrintModal";
import produce from "immer";
import { MantineReactTable } from "mantine-react-table";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useQuery } from "react-query";
import { useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";
import {
  getBodyContent,
  getCsvContent,
  getCustomId,
  getFields,
  getFilterPayload,
  getHeaders,
  getTotal,
} from "services/filterHelperFunctions";
import { api_filter } from "services/master.service";

import BatchMaster from "./BatchMaster";
import dummyData from "./dummyData.json";
import { products_api } from "./products.service";
import AppBreadcrumb from "../../../components/AppBreadcrumb";
import { image_url } from "../../../config";
import { api_deleteProduct, api_getProducts } from "../../../services/product.service";
import { showErrorToast, showSuccessToast } from "../../../utilities/Toast";
import BarcodeManager from "components/BarcodeManager";
import Barcode from "react-barcode";
import { IconAlertTriangle } from "@tabler/icons";
const confirm_delete_props = {
  title: "Please confirm delete product",
  children: (
    <Text size="sm">
      Are you sure you want to delete this product ? Everything related to this product will be
      deleted.
    </Text>
  ),
  labels: { confirm: "Delete Product", cancel: "Cancel" },
  onCancel: () => console.log("Cancel"),
  confirmProps: { color: "red" },
};

export default function ProductsList() {
  const navigate = useNavigate("/");
  let isMobileScreen = useMediaQuery("(max-width: 768px)");
  const [head, setHead] = useState([]);
  const [body, setBody] = useState([]);
  const [foot, setFoot] = useState([]);
  const [csv, setCsv] = useState([]);
  const [isCsv, setIsCsv] = useState(false);

  // START : States
  const [selectedProduct, setSelectedProduct] = useState({});
  const [productsData, setProductsData] = useState([]);
  const [filename, setFilename] = useState("file");
  // END : States

  // STARTS : States
  const [userFormVisible, setUserFormVisible] = useState(false);
  const [showUpdateOptions, setShowUpdateOptions] = useState(false);
  const [viewMode, setViewMode] = useState(); // 'date' or 'product'
  // const [Date, setDate] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [batchList, setBatchList] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showSyncButton, setShowSyncButton] = useState(true);
  // const [endDate, setEndDate] = useState("");
  const [startProductCode, setStartProductCode] = useState("");
  const [endProductCode, setEndProductCode] = useState("");
  // ENDS : States
  const [columnFilters, setColumnFilters] = useState([]);

  const [enableMinQty, setEnableMinQty] = useState({})
  const [showSyncSelectedButton, setShowSyncSelectedButton] = useState(false);
  const [duplicateBatchesModal, setDuplicateBatchesModal] = useState(false);
  const [duplicateBatchesList, setDuplicateBatchesList] = useState([]);
  // Barcode modal state + print ref
const [showBarcodeModal, setShowBarcodeModal] = useState(false);
const [barcodeData, setBarcodeData] = useState([]); // array of strings like "115101-B06259L"
const barcodePrintRef = useRef(null);
const [isProductCodeMode, setIsProductCodeMode] = useState(false);
const [alreadyRefs, setAlreadyRefs] = useState([]);
const [showAlreadyModal, setShowAlreadyModal] = useState(false);
const [productsCounts, setProductsCounts] = useState({
  active : 0,
  outOfStock: 0,
  lessThanMinQty: 0,
  activeOutOfStock: 0
});
const [errorProductCodes, setErrorProductCodes] = useState([]);
const [selectedBatchStockDetails, setSelectedBatchStockDetails] = useState(null);

 const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [productsCount,setProductsCount] = useState(0)
  //Reset Pagination to 0
  useEffect(() => {
    setPagination(p => ({ ...p, pageIndex: 0 }));
  }, [columnFilters]);


// ✅ KEEP THIS AT TOP (above printFilter & printFilter_productCodeWise)
const sortByProductName = (a, b) => {
  const aVal = String(a.title || "").trim();
  const bVal = String(b.title || "").trim();

  const aStartsWithNumber = /^\d/.test(aVal);
  const bStartsWithNumber = /^\d/.test(bVal);

  // 1️⃣ number-start names first
  if (aStartsWithNumber && !bStartsWithNumber) return -1;
  if (!aStartsWithNumber && bStartsWithNumber) return 1;

  // 2️⃣ natural alphabetical (handles 2 Rice < 10 Sugar)
  return aVal.localeCompare(bVal, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};




const calculateTotalTableWidth = (columns) => {
  return columns.reduce((total, col) => total + (col.size || 100), 0);
};

const fetchDuplicateBatches = async () => {
    const today = dayjs().format("YYYY-MM-DD");
    
    const response = await products_api.fetchByUnassigned(today); 
    
    return response; 
};

const { 
    isLoading: duplicateBatchesIsLoading, 
    refetch: fetchDuplicates 
} = useQuery(
  ["duplicateUnassignedBatches"],
  fetchDuplicateBatches,
  {
    enabled: false, 
    onSuccess: (response) => {

        if (!response?.data || response.data.length === 0) {
      
          showErrorToast({
            title: "No Unassigned Batches",
            message: "No Unassigned Batches",
          });
      
          // setBatchList([]);
          setDuplicateBatchesList([]);
          return;
        }
      
        // ✅ Success
        showSuccessToast({
          title: "Unassigned Batches Fetched",
          message: "Unassigned batches loaded successfully.",
        });
      
        setBatchList(response?.data || []);
        setDuplicateBatchesList(response?.duplicates || []);
      },
    onError: (error) => {
     showErrorToast({
       title: "Error",
       message: error?.message || "Something went wrong",
     });
   
    //  setBatchList([]);
     setDuplicateBatchesList([]);
       },
  }
);
const handleBarcodePrint = useReactToPrint({
  content: () => barcodePrintRef.current,
  documentTitle: "Batch_Barcodes",
  // optional: onAfterPrint: () => setShowBarcodeModal(false),
});

 useEffect(() => {
    if (dummyData?.length) {
      const normalized = dummyData.map((p) => ({
        ...p,
        active: p.active === true, // ensure false if missing
      }));
      setProductsData(normalized);
    }
  }, [ dummyData]);

  // const activeCount = useMemo(
  //   () => productsData.filter((p) => p.active).length,
  //   [productsData]
  // );
//   const activeOutOfStockCount = useMemo(() => {
//   return productsData.filter((p) => {
//     const raw = p.stock_qty ?? p.stock ?? 0;
//     const stock = parseFloat(raw);
//     // only count if product is active AND stock is missing/zero/negative
//     return p.active && (isNaN(stock) || stock <= 0);
//   }).length;
// }, [productsData]);

// const lessThanMinQtyCount= useMemo(() => {
//   return productsData.filter((p) => {
//     const stock = parseFloat(p.stock_qty ?? p.stock ?? 0);
//     const minQty = parseFloat(p.min_qty ?? 0);
//     return p.active && !isNaN(stock) && !isNaN(minQty) && stock <= minQty;
//   }).length;
// }, [productsData]);

//     const outOfStockCount = useMemo(() => {
//     return productsData.filter((p) => {
//       const stock = parseFloat(p.stock_qty);
//       return isNaN(stock) || stock <= 0;
//     }).length;
//   }, [productsData]);

  const toggleActive = (id) => {
    setProductsData((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, active: !p.active } : p
      )
    );
  };
 



  

  const openDeleteConfirmation = id => {
    openConfirmModal({
      ...confirm_delete_props,
      onConfirm: async () => await deleteProduct(id),
    });
  };

  const deleteProduct = async id => {
    await api_deleteProduct(id)
      .then(res => {
        if (res.success) {
          showSuccessToast({ title: "Deleted Product", message: res.message });
        } else {
          showErrorToast({ title: "Error", message: res.message });
        }
      })
      .catch(e => {
        showErrorToast({ title: "Error", message: e.message });
      });
  };

const syncBatches = async () => {
  const res = await products_api.syncBatches();

  if (res.success) {

    showSuccessToast({
      title: "Success",
      message: `${res.synced_count} batches synced successfully.`,
    });

    if (res.error_codes && res.error_codes.length > 0) {

      // ✅ முக்கியம்: string ஆக convert
      setErrorProductCodes(res.error_codes.map(String));

      showErrorToast({
        title: "Undefined Product Codes",
        message: res.error_codes.join(", "),
      });
    } else {
      setErrorProductCodes([]); // reset if no error
    }

    // ✅ table refresh
    await filterBatches();

  } else {
    showErrorToast({
      title: "Error",
      message: "Batch sync failed.",
    });
  }
};

const updateBatches = async () => {
  // Filter only selected rows
  const selectedRows = batchList.filter(row => selectedIds.includes(row.id));

  // Prepare JSON payload
  const payload = selectedRows.map(row => ({
    id: row.id,
    product_id: row.product_id,
    product_code: row.product_code,
    batch_no: row.batch_no,
    exp_date: row.exp_date,
    mrp: row.mrp,
    stock: row.stock,
    selling_price: row.selling_price,
  }));

  try {
    const res = await products_api.updateBatches(payload);

    if (res.success) {
      showSuccessToast({
        title: "Success",
        message: "Batches updated successfully.",
      });

      // ✅ 1. Clear selected checkboxes
      setSelectedIds([]);

      // ✅ 2. Refresh the current view
      await filterBatches(); 

      // ✅ 3. Also refetch duplicate batch list ONLY if in unassigned mode
      if (viewMode === 'unassign') {
        await fetchDuplicates();
      }
    } else {
      showErrorToast({
        title: "Error",
        message: res.message || "Error in updating batches.",
      });
    }
  } catch (error) {
    console.error("Update failed:", error);
    showErrorToast({
      title: "Error",
      message: "Something went wrong while updating.",
    });
  }
};

useEffect(() => {
  if (viewMode === 'unassign') {
    filterBatches();
  }
}, [viewMode]);

const filterBatches = async () => {
  setShowTable(false);

  // Unassigned batches
  if (viewMode === 'unassign') {
  const res = await products_api.fetchByUnassigned(); // backend now ignores date

  if (res.success) {
    setBatchList(res.data);
    setColumnFilters(false);
    setShowSyncButton(true);
    setShowTable(true);
    showSuccessToast({
      title: "Success",
      message: "Unassigned batches fetched.",
    });
  } else {
    setShowTable(false);
    showErrorToast({
      title: "No Unassigned Batches",
      message: "No unassigned batches found.",
    });
  }
}


  else if (viewMode === 'product') {
    if (!startProductCode || !endProductCode) {
      showErrorToast({
        title: "Missing Codes",
        message: "Enter both start and end product codes.",
      });
      return;
    }

    const res = await products_api.fetchByProductCodes(
      startProductCode,
      endProductCode
    );

    if (res.success) {
      console.log(res.data);
        setBatchList(res.data);
        setColumnFilters(false);
        setShowSyncButton(false);
        setShowTable(true);
      showSuccessToast({
        title: "Success",
        message: "Product code-wise data fetched.",
      });
    } else {
      setShowTable(false);
      showErrorToast({
        title: "Error",
        message: "Product code-wise fetch failed.",
      });
    }
  }
};
 

  const changeMinQty = (id, qty) => {
    setProductsData(
      produce(draft => {
        let product = draft.find(e => e.id === id);
        product.min_qty = qty;
      })
    );
  };

  const handleMinQtyChange = async (productId, min_qty) => {
    console.log(productId);

  try {
    const res = await products_api.change_min_qty(
      { product_id: productId },
      min_qty
    );
    
    if (res.success) {
      setProductsData(prev => 
        prev.map(product => 
          product.id === productId 
            ? { ...product, min_qty: Number(min_qty) } 
            : product
        )
      );
      
      showSuccessToast({ 
        title: "Success", 
        message: "Minimum quantity updated successfully" 
      });
      products.refetch();
      
    } else {
      showErrorToast({ title: "Error", message: res.message });
      products.refetch();
    }
  } catch (error) {
    showErrorToast({ title: "Error", message: error.message });
    products.refetch();
  }
};
    const syncSelectedBatches = async () => {
    if (selectedIds.length === 0) return;
    
    await products_api.syncSelectedBatches(selectedIds).then(res => {
      console.log(res);
      if (res.success) {
        showSuccessToast({
          title: "Success",
          message: "Selected batches synced successfully.",
        });
      } else {
        showErrorToast({
          title: "Error",
          message: "Error in syncing selected batches.",
        });
      }
    });
  };
   useEffect(() => {
    setShowSyncSelectedButton(selectedIds.length > 0);
  }, [selectedIds]);

  const MinQtyCell = ({ data }) => {
    const isEditing = enableMinQty?.[data.product_code];

    const enable = () => {
      setEnableMinQty(prev => ({
        ...prev,
        [data.product_code]: true,
      }));
    };

    const triggerApi = (e) => {
      handleMinQtyChange(data?.id, e.target.value)
    }

    

    return (
      <div style={{ minWidth: '60px' }}>
        {isEditing ? (
          <NumberInput
            type="number"
            min={0}
            autoFocus
            defaultValue={data?.min_qty ? data?.min_qty : 0}
            onBlur={(e) => {
              triggerApi(e)
              setEnableMinQty(prev => ({
                ...prev,
                [data.product_code]: false,
              }))
            }
            }
          />
        ) : (
          <div
            // onDoubleClick={enable}
            style={{
              padding: '4px 6px',
              borderRadius: '4px',
            }}
          >
            {data?.min_qty ? data?.min_qty : 0}
          </div>
        )}
      </div>
    );
  };

  const columns = useMemo(
    () => {
    const baseColumns = [
      {
        header: "Product Code",
        accessorKey: "product_code",
        size: 40, // Fixed smaller width
        minSize: 40,
        filterVariant: "range",
        mantineFilterTextInputProps: {
        style: { 
          minWidth: '40px', 
          maxWidth: '40px',
          fontSize: '12px'
        },
        size: 'xs'
      },
    },
      {
        header: "Product",
        accessorKey: "title",
        size: 155, // Fixed width
        minSize: 150,
        Cell: ({ renderedCellValue, row }) => (
          <Flex align={"center"}>
            <img
              src={
                row.original.thumbnail
                  ? image_url + row.original.thumbnail
                  : "https://universalele.websites.co.in/obaju-turquoise/img/product-placeholder.png"
              }
              width={20}
              height={20}
              style={{
                borderRadius: 100,
                border: "2px solid #eee",
                objectFit: "cover",
                flexShrink: 0,
              }}
              alt=""
            />
            <Text ml={8} style={{ 
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            
          }}> 
            {renderedCellValue} 
          </Text>
          </Flex>
        ),
      },
      {
        header: "Category",
        accessorKey: "category",
        size: 80,
        minSize: 80,
        filterVariant: "text",
      mantineFilterSelectProps: {
        style: { 
          minWidth: '70px', 
          maxWidth: '80px'
        },
        size: 'xs',
      },
      },
      {
        header: "Sub Category",
        accessorKey: "sub_category",
        size: 80,
        minSize: 80,
        filterVariant: "text",
      mantineFilterSelectProps: {
        style: { 
          minWidth: '70px', 
          maxWidth: '80px'
        },
        size: 'xs',
      },
      },
      // {
      //   header: "Pushed At",
      //   accessorKey: "updated_at",
      //   size: "auto",
      //   filterVariant: "date-range",
      // },

      {
        header: "Pushed At",
        accessorKey: "updated_at",
        size: 120,
        minSize: 100,
        filterVariant: "date-range",
        mantineTableHeadCellProps: {
        style: { 
          minWidth: '100px', 
          maxWidth: '190px' 
        }
  },
        Cell: ({ cell }) => {
          const dateValue = cell.getValue();
          if (!dateValue) return '';
          
          try {
            const date = new window.Date(dateValue);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            
            return `${day}/${month}/${year}`;
          } catch (error) {
            console.error('Date parsing error:', error);
            return dateValue; // Return original value if parsing fails
          }
        }
      },

      {
        header: `Stock (${productsCounts.outOfStock})`,
  //       (
  //   <Flex align="center" gap={6}>
  //     {/* <Text>Stock</Text> */}
  //     <Text color="red" fw={600}>
  //       ({outOfStockCount})
  //     </Text>
  //   </Flex>
  // ),
        accessorKey: "stock_qty",
        size: 35,
        minSize: 30,
        filterVariant: "range",
        mantineFilterTextInputProps: {
        style: { 
          minWidth: '25px', 
          maxWidth: '30px',
          fontSize: '12px'
        },
        size: 'xs'
      },
        Cell: ({ cell }) => {
          let val = +cell.getValue();
          let color;
          if (val <= 50 && val >= 10) {
            color = "yellow";
          } else if (val <= 10) {
            color = "red";
          } else {
            color = "light";
          }

          return (
            <Badge fz={"12px"} fw={"bold"} variant={"light"} color={color}>
              {val > 0 ? Number(val).toFixed(3) : "OutofStock"}
            </Badge>
          );
        },
      },
      {
        header: "Min Qty",
        accessorKey: "min_qty",
        size: 40,
        minSize: 30,
       filterVariant: "range",
      mantineFilterTextInputProps: {
        style: { 
          minWidth: '30px', 
          maxWidth: '30px',
          fontSize: '12px'
        },
        size: 'xs'
      },
  Cell: ({ row, table }) => {
    const [value, setValue] = useState(row.original.min_qty ?? 0);
    const [isEditing, setIsEditing] = useState(false);

    // Reset value when row data changes
    useEffect(() => {
      setValue(row.original.min_qty ?? 0);
    }, [row.original.min_qty]);

    const handleSave = async () => {
      const numValue = Number(value);
      const originalValue = row.original.min_qty ?? 0;
      
      if (numValue !== originalValue) {
        await handleMinQtyChange(row.original.id, numValue);
      }
      setIsEditing(false);
    };

    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        handleSave();
      } else if (e.key === 'Escape') {
        setValue(row.original.min_qty ?? 0);
        setIsEditing(false);
      }
    };

    if (isEditing) {
      return (
        <NumberInput
          value={value}
          onChange={setValue}
          onBlur={handleSave}
          onKeyDown={handleKeyPress}
          autoFocus
          min={0}
          step={1}
          style={{ width: '80px' }}
          size="xs"
        />
      );
    }

    return (
      <div
        onClick={() => setIsEditing(true)}
        style={{
                width: "100%",
                border: "none",
                background: "transparent",
                textAlign: "center"
              }}
        title="Click to edit minimum quantity"
        onDoubleClick={(e) => {
          e.stopPropagation();
          setIsEditing(true);
        }}
      >
        {value || 0}
      </div>
     );
        },
      },
      {
        header: `Active (${productsCounts.active})`,
        accessorKey: "active",
        size: 50,
        minSize: 40,
        filterVariant: "select",
        mantineFilterSelectProps: {
        style: { 
          minWidth: '40px', 
          maxWidth: '40px'
        },
        size: 'xs',
        data: ["true", "false"]
      },
        Cell: ({ cell, row }) => (
          <Switch
            onChange={e =>handleStatusChange(row.original.id, e.target.checked)}
            checked={row.original.active}
            size={"xs"}
          />
        ),
      },
      
    ];
    
        const totalWidth = calculateTotalTableWidth(baseColumns);
    console.log('Total table width:', totalWidth, 'px');
    
    return baseColumns;
  },
    [productsData,  enableMinQty, productsCounts]
  );

//   // update batach table column
// const tableColumns = [
//   {
//     id: "select",
//     header: "",
//     size: 30,
//     Cell: ({ row }) => (
//       <input
//         type="checkbox"
//         checked={selectedIds.includes(row.original.product_code)}  // Use product_code
//         onChange={(e) => {
//           const code = row.original.product_code;  // Use product_code
//           if (e.target.checked) {
//             setSelectedIds((prev) => [...prev, code]);
//           } else {
//             setSelectedIds((prev) => prev.filter((item) => item !== code));
//           }
//         }}
//       />
//     ),
//   },
//   {
//     accessorKey: "product_code",
//     header: "Product Code",
//   },
//   {
//     accessorKey: "title",
//     header: "Product",
//   },
//   {
//     accessorFn: row => row.active_batches?.[0]?.batch_no || "-",
//     id: "batch_no",
//     header: "Batch No",
//   },
//   {
//     accessorFn: row => row.active_batches?.[0]?.exp_date || "-",
//     id: "exp_date",
//     header: "Expiry Date",
//   },
//   {
//     accessorFn: row => row.active_batches?.[0]?.mrp || "-",
//     id: "mrp",
//     header: "MRP",
//   },
//   {
//     accessorFn: row => row.active_batches?.[0]?.qty || "-",
//     id: "qty",
//     header: "Quantity",
//   },
//   {
//     accessorFn: row => row.active_batches?.[0]?.selling_price || "-",
//     id: "selling_price",
//     header: "Selling Price",
//   },
// ];

const tableColumns = [


{
  id: "select",
  header: "",
  size: 30,
  Cell: ({ row }) => {
    const isAssigned = row.original.product_id ? true : false; // Assigned check
    return (
      <input
        type="checkbox"
        checked={selectedIds.includes(row.original.id)}
        disabled={viewMode === "unassign" && isAssigned}  // disable only for date-wise + Assigned
        onChange={(e) => {
          const code = row.original.id;
          if (e.target.checked) {
            setSelectedIds((prev) => [...prev, code]);
          } else {
            setSelectedIds((prev) => prev.filter((item) => item !== code));
          }
        }}
      />
    );
  },
},
 

  {
    accessorKey: "product_code",
    header: "Product Code",
    size: "auto"
  },
  {
    accessorKey: "title",
    header: "Product",
  },

  // Editable Batch No
  {
    accessorKey: "batch_no",
    header: "Batch No",
    size: "auto",
    Cell: ({ row }) => {
      const [value, setValue] = React.useState(row.original.batch_no || "");
      return (
        <input
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setBatchList(prev =>
              prev.map(item =>
              item.id === row.original.id 
                ? { ...item, batch_no: e.target.value }
                  : item
              )
            );
          }}
          style={{ width: "100%", border: "none", background: "transparent" }}
        />
      );
    },
  },
  ...(viewMode === "date"
    ? [
        {
          accessorKey: "applicable_date",
          header: "Applicable Date",
          size: "auto",
          Cell: ({ row }) => {
            const value = row.original.applicable_date || "N/A";
            return (
              <span style={{ fontWeight: "bold" }}>
                {dayjs(value).isValid()
                  ? dayjs(value).format("DD-MM-YYYY")
                  : value}
              </span>
            );
          },
        },
      ]
    : []),
  

  // Editable Expiry Date
    ...(viewMode !== "date"
    ? [
  {
    accessorKey: "exp_date",
    header: "Expiry Date",
    size: "auto",
    Cell: ({ row }) => {
      const [value, setValue] = React.useState(row.original.exp_date || "");
      return (
        <input
          type="date"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setBatchList(prev =>
              prev.map(item =>
                item.id === row.original.id
                  ? { ...item, exp_date: e.target.value }
                  : item
              )
            );
          }}
          style={{ width: "100%", border: "none", background: "transparent" }}
        />
      );
    },
  },

        ]
    : []),

  // Editable MRP
   
  {
    accessorKey: "mrp",
    header: "MRP",
    size: "auto",
    Cell: ({ row }) => {
      const [value, setValue] = React.useState(row.original.mrp || "");
      return (
        <input
          type="number"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setBatchList(prev =>
              prev.map(item =>
                item.id === row.original.id
                  ? { ...item, mrp: e.target.value }
                  : item
              )
            );
          }}
          style={{ width: "100%", border: "none", background: "transparent" }}
        />
      );
    },
  },
    

  ...(viewMode === "product" ? [
  // Total Quantity
  {
    header: "Total Qty",
    size: "auto",
    Cell: ({ row }) => {
      const mainStock = Number(row.original.stock || 0);
      const counterStocksTotal = (row.original.counter_stocks || []).reduce((acc, c) => acc + (Number(c.stock) || 0), 0);
      const totalStock = mainStock + counterStocksTotal;
      return (
        <span style={{ fontWeight: "bold" }}>
          {totalStock}
        </span>
      );
    },
  }
  ] : [
  // Editable Quantity
  {
    accessorKey: "stock",
    header: "Quantity",
    size: "auto",
    Cell: ({ row }) => {
      const [value, setValue] = React.useState(row.original.stock || "");
      return (
        <input
          type="number"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setBatchList(prev =>
              prev.map(item =>
                item.id === row.original.id
                  ? { ...item, stock: e.target.value }
                  : item
              )
            );
          }}
          style={{ width: "100%", border: "none", background: "transparent" }}
        />
      );
    },
  }
  ]),

  // Editable Selling Price
    ...(viewMode !== "date"
    ? [
  {
    accessorKey: "selling_price",
    header: "Selling Price",
    size: "auto",
    Cell: ({ row }) => {
      const [value, setValue] = React.useState(row.original.selling_price || "");
      return (
        <input
          type="number"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setBatchList(prev =>
              prev.map(item =>
                item.id === row.original.id
                  ? { ...item, selling_price: e.target.value }
                  : item
              )
            );
          }}
          style={{ width: "100%", border: "none", background: "transparent" }}
        />
      );
    },
  },

        ]
    : []),
  // ✅ Only add Product Allocate column in Date Wise mode
  ...(viewMode === "unassign"
    ? [
        {
        accessorKey: "applicable_date",
        header: "Applicable Date",
        size: "auto",
        Cell: ({ row }) => {
          const value = row.original.applicable_date || "N/A";
          return (
            <span style={{ fontWeight: "bold" }}>
              {dayjs(value).isValid() ? dayjs(value).format("DD-MM-YYYY") : value}
            </span>
          );
        },
      },
  {
  accessorFn: (row) => {
    // ✅ FIRST check error codes
    if (errorProductCodes.includes(String(row.product_code))) {
      return "Undefined";
    }

    return row.product_id ? "Assigned" : "Unassigned";
  },
  id: "product_allocate",
  header: "Product Allocate",
  size: "auto",
  Cell: ({ cell }) => {
    const value = cell.getValue();

    let bgColor = "#f8d7da";
    let textColor = "#721c24";

    if (value === "Assigned") {
      bgColor = "#d4edda";
      textColor = "#155724";
    } else if (value === "Undefined") {
      bgColor = "#fff3cd";   // yellow
      textColor = "#856404";
    }

    return (
      <span
        style={{
          display: "inline-block",
          padding: "2px 8px",
          borderRadius: "8px",
          backgroundColor: bgColor,
          color: textColor,
          fontWeight: "bold",
        }}
      >
        {value}
      </span>
    );
  },
}

      ]
    : []),

  ...(viewMode === "product"
    ? [    
// {
//   accessorKey: "bb_day",
//   header: "BB Day",
//   size: "auto",
//   Cell: ({ row }) => {
//     const expDateStr = row.original.exp_date; // backend date
//     let displayText = "N/A";
//     let bgColor = "#f8d7da";
//     let textColor = "#721c24";

//     if (expDateStr) {
//       const today = dayjs().startOf('day'); // today at midnight
//       const expiry = dayjs(expDateStr).startOf('day'); // backend expiry at midnight
//       const diffDays = expiry.diff(today, 'day'); // difference in days

//       if (diffDays > 0) {
//         displayText = `${diffDays} Days`;
//         bgColor = "#d4edda";
//         textColor = "#155724";
//       } else if (diffDays === 0) {
//         displayText = "Expires Today";
//         bgColor = "#fff3cd";
//         textColor = "#856404";
//       } else {
//         displayText = "Expired";
//         bgColor = "#f8d7da";
//         textColor = "#721c24";
//       }
//     }

//     return (
//       <span
//         style={{
//           display: "inline-block",
//           padding: "2px 8px",
//           borderRadius: "8px",
//           backgroundColor: bgColor,
//           color: textColor,
//           fontWeight: "bold",
//         }}
//       >
//         {displayText}
//       </span>
//     );
//   },
// }
{
  accessorFn: (row) => {
    if (!row.exp_date) return "N/A";
    const today = dayjs().startOf("day");
    const expiry = dayjs(row.exp_date).startOf("day");
    const diffDays = expiry.diff(today, "day");

    if (diffDays > 0) return `${diffDays} Days`;
    if (diffDays === 0) return "Expires Today";
    return "Expired";
  },
  id: "bb_day", // required since accessorFn is used
  header: "BB Day",
  size: "auto",
  Cell: ({ cell }) => {
    const value = cell.getValue();
    let bgColor = "#f8d7da";
    let textColor = "#721c24";

    if (value.includes("Days")) {
      bgColor = "#d4edda";
      textColor = "#155724";
    } else if (value === "Expires Today") {
      bgColor = "#fff3cd";
      textColor = "#856404";
    }

    return (
      <span
        style={{
          display: "inline-block",
          padding: "2px 8px",
          borderRadius: "8px",
          backgroundColor: bgColor,
          color: textColor,
          fontWeight: "bold",
        }}
      >
        {value}
      </span>
    );
  },
}

]
: []),

  ...(viewMode === "product" ? [
  {
    id: "stock_details",
    header: "Distribution",
    size: "auto",
    Cell: ({ row }) => {
      return (
        <ActionIcon
          sx={theme => ({ color: theme.colors.brand[7] })}
          onClick={() => {
            setSelectedBatchStockDetails(row.original);
          }}
        >
          <IconEye style={{ width: 20 }} />
        </ActionIcon>
      );
    },
  }
  ] : []),
];



  const changeStatus = (id, status) => {
    setProductsData(
      produce(draft => {
        let product = draft.find(e => e.id === id);
        product.active = status;
      })
    );
  };

  const handleStatusChange = async (productId, status) => {
    console.log(productId);

    try {
    const res = await products_api.change_active_status({
      product_id: productId,
      status, // 👈 send new status
    });
    if (res.success) {
      changeStatus(productId, status); // updates local
      products.refetch();
      showSuccessToast({ 
        title: "Success", 
        message: `Product ${status ? 'activated' : 'deactivated'} successfully` 
      });
    } else {
      showErrorToast({ title: "Error", message: res.message });
    }
  } catch (e) {
    showErrorToast({ title: "Error", message: e.message });
  }
};



  const products = useQuery({
    queryKey: ["products_list",pagination.pageIndex,pagination.pageSize, columnFilters], // Include filters in queryKey
    queryFn: async () => {
      if (columnFilters.length > 0) {
        // WITH FILTERS: Use printFilter which should return filtered counts
      const response = await printFilter(false);
      return {
        data: response.data,
        count: response.count,
        counts: response.counts // This should be filtered counts
      };
      } else {
        return products_api.get(pagination.pageIndex + 1, pagination.pageSize);
      }
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  onSuccess: (data) => {
    if (data && data.data) {
      // Normalize the data to ensure consistent structure
      const normalizedData = data.data.map(product => ({
        ...product,
        min_qty: product.min_qty !== undefined && product.min_qty !== null 
          ? Number(product.min_qty) 
          : 0,
        active: product.active === true,
        stock_qty: product.stock_qty ?? product.stock ?? 0
      }));
      setProductsData(normalizedData);
      setProductsCount(data?.count)

   // Set counts from the response
      setProductsCounts({
        active: data?.counts?.active || 0,
        outOfStock: data?.counts?.outOfStock || 0,
        lessThanMinQty: data?.counts?.lessThanMinQty || 0,
        activeOutOfStock: data?.counts?.activeOutOfStock || 0
      });
      
      console.log("Final counts:", data?.counts);
    }
  },
  onError: (error) => {
    console.error("Error fetching products:", error);
    showErrorToast({ title: "Error", message: "Failed to load products" });
  }
});

const tableMeta = useMemo(() => ({
  refetch: products.refetch,
}), [products.refetch]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (body.length !== 0 && head.length !== 0) {
      if (!isCsv) {
        handlePrint();
        setBody([]);
        setHead([]);
      }
    }
    setIsCsv(false);
  }, [body, head]);

const printFilter = async (forCsv = true) => {
  const model = "Products";

  // ✅ Keep appendData clean — never add /media/ here
  const appendData = [
    ...(forCsv ? [] : [{ id: "id", append: "" }]),
    { id: "product_code", append: "" },
    { id: "title", append: "" },
    { id: "category__title", append: "", replace_id: "category" },
    { id: "sub_category__title", append: "", replace_id: "sub_category" },
    { id: "updated_at", append: "" },
    { id: "stock_qty", append: "" },
    { id: "min_qty", append: "" },
    { id: "active", append: "" },
    // include thumbnail only for filtering view (not for CSV)
    ...(forCsv ? [] : [{ id: "thumbnail", append: "" }]),
  ];

  const custom = getCustomId(columns, columnFilters, appendData);
  const filterPayload = getFilterPayload(custom?.columns, custom?.columnFilters);
  const fields = getFields(custom?.columns);

  try {
    const res = await api_filter(model, filterPayload, fields,"ProductsAdminSerializer", null, pagination.pageIndex + 1, pagination.pageSize,forCsv);
    console.log("filterPayload:", filterPayload, "fields:", fields);

    if (!res.success) {
      showErrorToast({ title: "Error", message: res.message });
      return { data: [],
        count: 0,
        counts: {
          active: 0,
          outOfStock: 0,
          lessThanMinQty: 0,
          activeOutOfStock: 0
        }
      };
    }
// 🔽 ADD THIS JUST AFTER API RESPONSE SUCCESS
const sortedData = [...res.data].sort(sortByProductName);
const count = res?.count
console.log("res print",res)
console.log("sort",sortedData,count)

let body_content = getBodyContent(sortedData, fields);

    if (forCsv) {
      // **CSV Export**
      const head_content = getHeaders(columns);
      const csv_content = getCsvContent(head_content, body_content, ["PRODUCTS"]);
      const columnTotalIndex = [5];
      const foot_content = getTotal(body_content, columnTotalIndex);

      setFilename(`PRODUCTS_WareHouse_${new Date().toLocaleDateString()}.csv`);
      setCsv(csv_content);
      setHead(head_content);
      setBody(body_content);
      setFoot(foot_content);
      // For CSV, return empty data since we're not using it
      return { 
        data: [],
        count: 0,
        counts: {
          active: 0,
          outOfStock: 0,
          lessThanMinQty: 0,
          activeOutOfStock: 0
        }
      };
    } else {
      // FOR DISPLAY WITH FILTERS: Make TWO API calls
      
      // 1️⃣ FIRST API CALL: Get ALL data for accurate counts (page 1, large page size)
      console.log("Fetching ALL data for counts...");
      const allDataRes = await api_filter(model, filterPayload, fields, "ProductsAdminSerializer", null,
                                          1, 10000, false); // Get up to 10000 rows
      
      if (!allDataRes.success) {
        showErrorToast({ title: "Error", message: "Failed to fetch data for counts" });
        return { 
          data: [],
          count: 0,
          counts: { active: 0, outOfStock: 0, lessThanMinQty: 0, activeOutOfStock: 0 }
        };
      }
      
      // 2️⃣ SECOND API CALL: Get paginated data for display
      console.log("Fetching paginated data for display...");
      const paginatedRes = await api_filter(model, filterPayload, fields, "ProductsAdminSerializer", null,
                                            pagination.pageIndex + 1, pagination.pageSize, false);
      
      if (!paginatedRes.success) {
        showErrorToast({ title: "Error", message: "Failed to fetch paginated data" });
        return { 
          data: [],
          count: 0,
          counts: { active: 0, outOfStock: 0, lessThanMinQty: 0, activeOutOfStock: 0 }
        };
      }
    const allSortedData = [...allDataRes.data].sort(sortByProductName);
      const allNormalized = allSortedData.map((p) => ({
  ...p,
  thumbnail: p.thumbnail ? image_url + p.thumbnail : "",
  category:
    p.category?.title ||
    p.category__title ||
    p.category__ ||
    p.category ||
    "",
  sub_category:
    p.sub_category?.title ||
    p.sub_category__title ||
    p.sub_category__ ||
    p.sub_category ||
    "",
  active: p.active === true,
}));

      const search =
        columnFilters.find((f) => f.id === "title")?.value?.toLowerCase() || "";

      const allFilteredData = allNormalized.filter(
        (p) =>
          !search ||
          p.title?.toLowerCase().includes(search) ||
          p.category?.toLowerCase().includes(search) ||
          p.sub_category?.toLowerCase().includes(search)
      );
      console.log(allFilteredData)
     // ✅ Calculate counts from the filtered data
      const calculatedCounts = {
        active: allFilteredData.filter(p => p.active).length,
        outOfStock: allFilteredData.filter(p => {
          const stock = parseFloat(p.stock_qty);
          return isNaN(stock) || stock <= 0;
        }).length,
        lessThanMinQty: allFilteredData.filter(p => {
          const stock = parseFloat(p.stock_qty ?? 0);
          const minQty = parseFloat(p.min_qty ?? 0);
          return p.active && !isNaN(stock) && !isNaN(minQty) && stock <= minQty;
        }).length,
        activeOutOfStock: allFilteredData.filter(p => {
          const stock = parseFloat(p.stock_qty);
          return p.active && (isNaN(stock) || stock <= 0);
        }).length
      };

      console.log("Calculated counts:", calculatedCounts);
// Process paginated data for display
      const paginatedSorted = [...paginatedRes.data].sort(sortByProductName);
      const paginatedNormalized = paginatedSorted.map((p) => ({
        ...p,
        // thumbnail: p.thumbnail ? `/media/${p.thumbnail}` : "",
        category: p.category?.title || p.category__title || p.category__ || p.category || "",
        sub_category: p.sub_category?.title || p.sub_category__title || p.sub_category__ || p.sub_category || "",
        active: p.active === true,
        stock_qty: parseFloat(p.stock_qty ?? p.stock ?? 0)
      }));

      // Apply same frontend filtering to paginated data
      const paginatedFiltered = paginatedNormalized.filter(
        (p) =>
          !search ||
          p.title?.toLowerCase().includes(search) ||
          p.category?.toLowerCase().includes(search) ||
          p.sub_category?.toLowerCase().includes(search)
      );

      console.log("📊 Counts from ALL data:", calculatedCounts);
      console.log("📄 Display data (paginated):", paginatedFiltered);
      console.log(`Total filtered rows: ${allFilteredData.length}, Displaying page: ${pagination.pageIndex + 1}`);

      return { data: paginatedFiltered,  count: allFilteredData.length,
      counts: calculatedCounts
      };  
    }
  } catch (e) {
    showErrorToast({ title: "Error", message: e.message });
    return { data: [] ,
      counts: {
        active: 0,
        outOfStock: 0,
        lessThanMinQty: 0,
        activeOutOfStock: 0
      }
    };
  }
};

const printFilter_productCodeWise = (forCsv = true) => {
  if (!batchList || batchList.length === 0) {
    showErrorToast({ title: "No Data", message: "No batch list found to export." });
    return;
  }

 const sortedBatchList = [...batchList].sort((a, b) => {
  const nameCompare = sortByProductName(a, b);
  if (nameCompare !== 0) return nameCompare;

  // same product name → batch no
  return String(a.batch_no || "").localeCompare(String(b.batch_no || ""));
});

  try {
    // Extract unique counter names dynamically
    const allCounterNamesSet = new Set();
    sortedBatchList.forEach((item) => {
      if (item.counter_stocks) {
        item.counter_stocks.forEach((cs) => {
          if (cs.counter_name) {
            allCounterNamesSet.add(cs.counter_name);
          }
        });
      }
    });
    const allCounterNames = Array.from(allCounterNamesSet).sort();

    if (forCsv) {
      // ✅ Convert batchList to clean CSV format matching table columns with counter breakup
      const csvData = sortedBatchList.map((item) => {
        const today = dayjs().startOf("day");
        const expiry = item.exp_date ? dayjs(item.exp_date).startOf("day") : null;
        const diffDays = expiry ? expiry.diff(today, "day") : null;

        let bb_day = "N/A";
        if (diffDays > 0) bb_day = `${diffDays} Days`;
        else if (diffDays === 0) bb_day = "Expires Today";
        else if (diffDays < 0) bb_day = "Expired";

        const csvRow = {
          "Product Code": item.product_code || "",
          "Product": item.title || "",
          "Batch No": item.batch_no || "",
          "Expiry Date": item.exp_date
            ? dayjs(item.exp_date).format("DD-MM-YYYY")
            : "",
          "MRP": item.mrp ?? "",
          "Main Warehouse": item.stock ?? 0,
        };

        allCounterNames.forEach((counterName) => {
          const found = (item.counter_stocks || []).find(
            (cs) => cs.counter_name === counterName
          );
          csvRow[counterName] = found ? (found.stock ?? 0) : 0;
        });

        const totalCounterStock = (item.counter_stocks || []).reduce(
          (sum, cs) => sum + (Number(cs.stock) || 0),
          0
        );
        csvRow["Total Qty"] = Number(item.stock || 0) + totalCounterStock;

        csvRow["Selling Price"] = item.selling_price ?? "";
        csvRow["BB Day"] = bb_day;

        return csvRow;
      });

      // ✅ Set filename and trigger CSV
      setFilename(
        `ProductCodeWise_${startProductCode}-${endProductCode}_${new Date().toLocaleDateString()}.csv`
      );
      setCsv(csvData);
      setIsCsv(true);
    } else {
      // ✅ Print Mode
      const head_content = [
        "Product Code",
        "Product",
        "Batch No",
        "Expiry Date",
        "MRP",
        "Main Warehouse",
        ...allCounterNames,
        "Total Qty",
        "Selling Price",
        "BB Day"
      ];

      const body_content = sortedBatchList.map((item) => {
        const today = dayjs().startOf("day");
        const expiry = item.exp_date ? dayjs(item.exp_date).startOf("day") : null;
        const diffDays = expiry ? expiry.diff(today, "day") : null;

        let bb_day = "N/A";
        if (diffDays > 0) bb_day = `${diffDays} Days`;
        else if (diffDays === 0) bb_day = "Expires Today";
        else if (diffDays < 0) bb_day = "Expired";

        const totalCounterStock = (item.counter_stocks || []).reduce(
          (sum, cs) => sum + (Number(cs.stock) || 0),
          0
        );
        const totalStock = Number(item.stock || 0) + totalCounterStock;

        const row = [
          item.product_code || "",
          item.title || "",
          item.batch_no || "",
          item.exp_date ? dayjs(item.exp_date).format("DD-MM-YYYY") : "",
          item.mrp ?? "",
          item.stock ?? 0,
        ];

        allCounterNames.forEach((counterName) => {
          const found = (item.counter_stocks || []).find(
            (cs) => cs.counter_name === counterName
          );
          row.push(found ? (found.stock ?? 0) : 0);
        });

        row.push(totalStock);
        row.push(item.selling_price ?? "");
        row.push(bb_day);

        return row;
      });

      const columnTotalIndex = [5];
      for (let i = 0; i <= allCounterNames.length; i++) {
        columnTotalIndex.push(6 + i);
      }
      const foot_content = getTotal(body_content, columnTotalIndex);

      setFilename(`ProductCodeWise_${startProductCode}-${endProductCode}_${new Date().toLocaleDateString()}.csv`);
      setIsCsv(false);
      setHead(head_content);
      setBody(body_content);
      setFoot(foot_content);
    }
  } catch (e) {
    showErrorToast({ title: "Error", message: e.message });
  }
};




  const csvRef = useRef();
  useEffect(() => {
    if (csv.length && isCsv) {
      csvRef.current.link.click();
      setCsv([]);
      setIsCsv(false);
    }
  }, [csv]);

  return (
    <>
      <CSVLink
        style={{ display: "none" }}
        asyncOnClick={true}
        data={csv}
        filename={filename}
        ref={csvRef}
      ></CSVLink>
      {isMobileScreen ? (
        <></>
      ) : (
        <Container fluid>
          <Box px={isMobileScreen ? 0 : 25} py={isMobileScreen ? 15 : 25}>
            <Flex justify={"space-between"} align="end" wrap={"wrap"}>
              <Box>
                <Text size={"lg"} fw={600} mb={10}>
                  Products
                </Text>
                <AppBreadcrumb
                  crumbs={[
                    {
                      text: "Master",
                    },
                    {
                      text: "Products",
                    },
                  ]}
                />
              </Box>
              <Flex align={"center"} justify={"center"} mt={isMobileScreen ? 10 : 0} gap={10}>
                <Button
                   onClick={() => {
                       setIsCsv(true);
                       if (isProductCodeMode) {
                         printFilter_productCodeWise(); // ✅ Run the new one
                       } else {
                         printFilter(); // ✅ Default full export
                       }
                     }}
                     leftIcon={<IconDownload />}
                   >
                     CSV
                </Button>
                 <Button
                   leftIcon={<IconPrinter />}
                   onClick={() => {
                     if (isProductCodeMode) {
                       printFilter_productCodeWise(false);
                     } else {
                       printFilter();
                     }
                   }}
                 >
                   Print
                 </Button>
                {/* <Button
                  onClick={() => {
                    navigate("add");
                  }}
                >
                  <IconPlus style={{ width: "20px" }} />
                  <Text ml={10}> Add Product </Text>
                </Button> */}
                {/* <Button variant="outline" onClick={syncBatches}>
                  <IconRefreshDot style={{ width: "20px" }} />
                  <Text ml={10}> Sync Batches </Text>
                </Button> */}
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowUpdateOptions(true); // 👈 This shows the container
                  }}
                >
                  <IconRefreshDot style={{ width: "20px" }} />
                  <Text ml={10}> Filter Batches </Text>
                </Button>
              </Flex>
            </Flex>
          </Box>
        </Container>
      )}

      {/* Update Batches Section */}
      {showUpdateOptions && ( // 👈 Conditional rendering starts here
        <Container fluid mt={10} mb={30}>
          <Paper p="md" shadow="sm" withBorder>
            <Group mb="md">
               <Button
                 variant={viewMode === 'unassign' ? 'filled' : 'outline'}
                 onClick={() => { 
                   setViewMode('unassign');
                   setSelectedIds([]);
                   setShowTable(false);
                   fetchDuplicates();
                   setIsProductCodeMode(false); 
                  //  filterBatches();   // 👈 trigger immediately on click
                 }}
               >
                 Unassigned Batches
               </Button>
              <Button
                variant={viewMode === 'product' ? 'filled' : 'outline'}
                onClick={() => { setViewMode('product');
                  setSelectedIds([]);
                  setShowTable(false);
                  setBatchList([]);           // ✅ clear old data
                  setBarcodeData([]);         // ✅ clear old barcodes
                  setShowBarcodeModal(false); // ✅ close modal
                  setIsProductCodeMode(true);
                }}
              >
                Product Code Wise
              </Button>
              <Button
             variant={viewMode === 'date' ? 'filled' : 'outline'}
             onClick={() => { 
               setViewMode('date');
               setSelectedIds([]);
               setShowTable(false);
               setBatchList([]);           // ✅ clear old data
               setBarcodeData([]);         // ✅ clear old barcodes
               setShowBarcodeModal(false); // ✅ close modal
               setIsProductCodeMode(false);
             }}
           >
             Date Wise
           </Button>
            </Group>



           {viewMode === 'date' && (
           <Group>
             <TextInput
               label="Applicable Date"
               type="date"
               value={selectedDate}
               onChange={(e) => setSelectedDate(e.currentTarget.value)}
             />
             <Button
      mt={25}
      style={{ fontSize: "20px" }}
      onClick={async () => {
        if (!selectedDate) {
          showErrorToast({
            title: "Missing Date",
            message: "Please select a date.",
          });
          return;
        }

       const res = await products_api.fetchBydate(selectedDate);

        if (res.success) {
          const batches = res.batches || res.data || [];
          const alreadyRefs = res.already_refs || [];
        
          // ✅ If no data found — show error toast and stop
          if (!batches || batches.length === 0) {
            setBatchList([]);
            setShowTable(false);
            showErrorToast({
              title: "No Data",
              message: "No batches found for this date.",
            });
            return;
          }
        
          // ✅ Find already printed batch IDs
          const alreadyTakenIds = alreadyRefs.map((r) => r.batch_id);
        
          // ✅ Set lists
          setBatchList(batches);
          setAlreadyRefs(alreadyRefs);
        
          // ✅ Auto-select corresponding checkboxes
          const autoSelectedIds = batches
            .filter((b) => alreadyTakenIds.includes(b.id))
            .map((b) => b.id);
          setSelectedIds(autoSelectedIds);
        
          setColumnFilters(false);
          setShowTable(true);
        
          // Optional: if you still want to show the modal when data exists
          if (alreadyRefs.length > 0) {
            setShowAlreadyModal(true);
          }
        
          // ✅ Success toast only when data exists
          showSuccessToast({
            title: "Success",
            message: "Date-wise batches fetched.",
          });
        } else {
          setShowTable(false);
          showErrorToast({
            title: "Error",
            message: res.message || "Failed to fetch batches.",
          });
        }

      }}
    >
               <IconArrowRight />
             </Button>
             
                      {batchList && batchList.length > 0 && (
            <>
              <Button
                variant="outline"
                color="green"
                mt={25}
                ml={10}
                onClick={() => {
                  const unselectedRows = batchList.filter((b) => !selectedIds.includes(b.id));

                  if (unselectedRows.length === 0) {
                    showErrorToast({
                      title: "No Data",
                      message: "No unselected rows found to generate barcodes.",
                    });
                    return;
                  }
                  
                  // ✅ Generate barcodes only for unselected rows
                  const barcodes = unselectedRows.flatMap((b) =>
                    Array.from({ length: Number(b.stock) || 0 }, () =>
                      `${b.product_code || ""}-${b.batch_no || ""}`
                    )
                  );


                  setBarcodeData(barcodes);
                  setShowBarcodeModal(true);
                }}
              >
                Generate Barcodes
              </Button>
              <BarcodeManager
                barcodeData={barcodeData}
                productList={productsData} 
                batchList={batchList}  
                applicableDate={selectedDate}    
                show={showBarcodeModal}
                onClose={() => setShowBarcodeModal(false)}
              />
            </>
          )}

          <Modal
      opened={showAlreadyModal}
      onClose={() => setShowAlreadyModal(false)}
      title={`Already Printed Batches for ${selectedDate}`}
      size="lg"
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #000", padding: 6 }}>Product</th>
            <th style={{ border: "1px solid #000", padding: 6 }}>Batch No</th>
            <th style={{ border: "1px solid #000", padding: 6 }}>Qty</th>
          </tr>
        </thead>
        <tbody>
          {alreadyRefs.map((r, i) => (
            <tr key={i}>
              <td style={{ border: "1px solid #000", padding: 6 }}>
                {r["batch__product__title"]}
              </td>
              <td style={{ border: "1px solid #000", padding: 6 }}>
                {r["batch__batch_no"]}
              </td>
              <td
                style={{
                  border: "1px solid #000",
                  padding: 6,
                  textAlign: "center",
                }}
              >
                {r.qty}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
        </Group>
      )}
      

            {viewMode === 'product' && (
              <Group>
                <TextInput
                  label="Start Product Code"
                  value={startProductCode}
                  onChange={(e) => setStartProductCode(e.target.value)}
                />
                <TextInput
                  label="End Product Code"
                  value={endProductCode}
                  onChange={(e) => setEndProductCode(e.target.value)}
                />
                <Button
                  onClick={filterBatches}
                  disabled={!startProductCode || !endProductCode}
                  mt={25}
                  style={{ fontSize: '20px'}}
                >
                 <IconArrowRight />
                </Button>
              
                {/* GENERATE BARCODE BUTTON */}
              {batchList && batchList.length > 0 && (
      <Button
        variant="outline"
        color="green"
        mt={25}
        ml={10}
        onClick={() => {
          // ✅ Prepare barcode strings for each batch
         const unselectedRows = batchList.filter((b) => !selectedIds.includes(b.id));

                  if (unselectedRows.length === 0) {
                    showErrorToast({
                      title: "No Data",
                      message: "No unselected rows found to generate barcodes.",
                    });
                    return;
                  }
                  
                  // ✅ Generate barcodes only for unselected rows
                  const barcodes = unselectedRows.flatMap((b) =>
                    Array.from({ length: Number(b.stock) || 0 }, () =>
                      `${b.product_code || ""}-${b.batch_no || ""}`
                    )
                  );
          setBarcodeData(barcodes);
          setShowBarcodeModal(true);
        }}
      >
        Generate Barcodes
      </Button>
    )}
    <BarcodeManager
      barcodeData={barcodeData}
      productList={productsData} 
      batchList={batchList}      
      show={showBarcodeModal}
      onClose={() => setShowBarcodeModal(false)}
    />
              </Group>

            )}
          </Paper>
        </Container>
      )}

{/* Update Products Table */}
     {/* {showTable && (
  <Container fluid mt={10} mb={30}>
    <Box px={isMobileScreen ? 5 : 25} sx={{ borderRadius: 2 }}>
      <Box className="datatable-wrapper">
        <MantineReactTable
          mantineTableProps={{ className: "datatable" }}
          // enableRowActions
          // positionActionsColumn="last"
          renderTopToolbarCustomActions={() => (
            <Box px={isMobileScreen ? 5 : 24} py={10}>
              <Text
                fw={600}
                tt="uppercase"
                size="sm"
                sx={theme => ({
                  letterSpacing: 1,
                  color: theme.colors.brand[7],
                })}
              >
                 Batch List
              </Text>
            </Box>
          )}
          // renderRowActions={({ row }) => (
          //   <Flex>
          //     <Tooltip label="View Product">
          //       <ActionIcon
          //         sx={theme => ({ color: theme.colors.brand[7] })}
          //         onClick={() => {
          //           navigate(`view/?id=${row.original.id}`);
          //         }}
          //       >
          //         <IconEye style={{ width: 20 }} />
          //       </ActionIcon>
          //     </Tooltip>

          //     <Tooltip label="Manage Batch">
          //       <ActionIcon
          //         ml={10}
          //         sx={theme => ({ color: theme.colors.brand[7] })}
          //         onClick={() => {
          //           setSelectedProduct(row.original);
          //           setUserFormVisible(true);
          //         }}
          //       >
          //         <IconPackage style={{ width: 20 }} />
          //       </ActionIcon>
          //     </Tooltip>

          //     <Tooltip label="Edit Product">
          //       <ActionIcon
          //         sx={theme => ({ color: theme.colors.brand[7] })}
          //         ml={10}
          //         onClick={() => {
          //           navigate(`edit?id=${row.original.id}`);
          //         }}
          //       >
          //         <IconEdit style={{ width: 20 }} />
          //       </ActionIcon>
          //     </Tooltip>

          //     <Tooltip label="Delete Product">
          //       <ActionIcon
          //         sx={theme => ({ color: theme.colors.red[6] })}
          //         ml={10}
          //         onClick={() => {
          //           openDeleteConfirmation(row.original.id);
          //         }}
          //       >
          //         <IconTrash style={{ width: 20 }} />
          //       </ActionIcon>
          //     </Tooltip>
          //   </Flex>
          // )}
          initialState={{ density: "xs" }}
          columns={batchColumns}
          data={batchList}
          enableDensityToggle={false}
          enableFullScreenToggle={isMobileScreen}
          enableColumnActions={false}
          enableStickyHeader
          enablePagination
          autoResetPageIndex={false}
          enableGlobalFilter={true}
        />
      </Box>
    </Box>
  </Container>
)} */}

{showTable && (
 <Container fluid mt={10} mb={30} style={{ position: 'relative', paddingBottom: '50px' }}>
    <Box px={isMobileScreen ? 5 : 25} sx={{ borderRadius: 2 }}>
      <Box className="datatable-wrapper">
        <MantineReactTable
            columns={tableColumns}
            data={batchList}
            key={batchList.length}
            initialState={{ density: "xs" }}
            enableDensityToggle={false}
            enableFullScreenToggle={isMobileScreen}
            enableColumnActions={false}
            enableStickyHeader
            enablePagination
            autoResetPageIndex={false}
            enableGlobalFilter={true}
          
            // ✅ correct prop to style rows dynamically
           mantineTableBodyRowProps={({ row }) => {
               if (viewMode !== "unassign") return {};

               // check if batch_no is in duplicates list
               const isDuplicate = duplicateBatchesList.includes(row.original.id);

               if (isDuplicate) {
                 return {
                   style: {
                     backgroundColor: "#ffe6e6", // light red highlight
                     transition: "background-color 0.3s ease",
                   },
                   sx: {
                     "& td": {
                       backgroundColor: "#ffe6e6 !important",
                     },
                   },
                 };
               }

                return {};
              }}
          
            renderTopToolbarCustomActions={() => (
              <Box
                px={isMobileScreen ? 5 : 24}
                py={10}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Text
                  fw={600}
                  tt="uppercase"
                  size="sm"
                  sx={(theme) => ({
                    letterSpacing: 1,
                    color: theme.colors.brand[7],
                  })}
                >
                  Batch List
                </Text>

                 <Button
  size="xs"
  variant="outline"
  fw={700}
  style={{
    marginLeft: 10,
    
    color:
      selectedIds.length === batchList.length
        ? "red"            // Unselect All
        : "darkgreen",     // Select All
    borderColor:
      selectedIds.length === batchList.length
        ? "red"
        : "darkgreen",
  }}
  onClick={() => {
    if (selectedIds.length === batchList.length) {
      setSelectedIds([]);
    } else {
      const allIds = batchList.map((b) => b.id);
      setSelectedIds(allIds);
    }
  }}
>
  {selectedIds.length === batchList.length ? "Unselect All" : "Select All"}
</Button>

          
                <Text
                  size="xs"
                  fw={600}
                  style={{ marginLeft: 10, fontFamily: "inherit", border: "1px solid black",
                     padding: "2px 6px",
                     borderRadius: "4px"}}
                >
                  {selectedIds.length} Selected
                </Text>
               

                {viewMode !== "unassign" && (
                <Text
                   size="xs"
                   fw={600}
                   style={{
                     marginLeft: 12,
                     color: "red",
                     border: "1px solid red",
                     padding: "2px 6px",
                     borderRadius: "4px"
                   }}
                 >
                   NOTE: UNSELECTED rows can generate barcodes
                 </Text>
                 )}
          
                {viewMode === "unassign" && duplicateBatchesList.length > 0 && (
                  <Text
                    size="xs"
                    fw={600}
                    style={{
                      marginLeft: 8,
                      color: "red",
                      border: "1px solid red",
                     padding: "2px 6px",
                     borderRadius: "4px"
                    }}
                  >
                    {duplicateBatchesList.length} Duplicate's
                  </Text>
                )}
              </Box>
            )}
          />

      </Box>
    </Box>
    {/* Sync Selected Button - Positioned at bottom left */}
    
{/* Buttons at bottom left */}
<Box
  style={{
    position: 'absolute',
    bottom: 10,
    left: isMobileScreen ? 15 : 30,
    zIndex: 100,
    display: 'flex',
    gap: '10px', // space between buttons
  }}
>

{showSyncButton && viewMode !== "date" && selectedIds.length === 0 && (
  <Button
    variant="outline"
    color="green"
    leftIcon={<IconRefreshDot style={{ width: "20px" }} />}
    onClick={syncBatches}
  >
    <Text ml={10}>Sync Selected Batches</Text>
  </Button>
)}

  {/* Update Batches - visible only if something selected */}
  {selectedIds.length > 0 && viewMode !== "date" && (
    <Button 
      variant="outline"
      color="green"
      leftIcon={<IconRefreshDot style={{ width: "20px" }} />}
      onClick={updateBatches}
    >
      <Text ml={10}>Update Batches</Text>
    </Button>
  )}
</Box>

  </Container>
)}


      {/* Main Products Table */}
      {columnFilters && (
      <Container fluid mt={10} mb={30}>
        <Box px={isMobileScreen ? 5 : 25} sx={{ borderRadius: 2 }}>
          <Box className="datatable-wrapper">
            <MantineReactTable
              onColumnFiltersChange={setColumnFilters}
              state={{ columnFilters, pagination, isLoading: products.isLoading || products.isRefetching }}
              isLoading={products.isLoading || products.isRefetching}
              mantineTableProps={{ className: "datatable" }}
              enableRowActions
              positionActionsColumn="last"
              meta={tableMeta}
              renderTopToolbarCustomActions={({ row }) => (
                <Box px={isMobileScreen ? 5 : 24} py={10}>
                      <Flex justify="space-between" align="flex-start" mb={2}>
                        <div style={{ width: '90%' }}> 
                      <Box style={{ marginLeft: '180%' }}> 
                            <Badge 
                              fz="12px" 
                              fw="bold" 
                              variant="light" 
                              color="orange"
                              sx={(theme) => ({
                     
                    transform: "translate(100px, 25px)", 
                      })}
                            >
                              Less Than MinQty({productsCounts.lessThanMinQty})
                            </Badge>
                          </Box>
                        </div>
                        
                        <div style={{ width: '10%' }}>
                          <Box style={{ marginLeft: '1300%' }}> 
                            <Badge 
                              fz="12px" 
                              fw="bold" 
                              variant="light" 
                              color="red"
                              sx={(theme) => ({
                     
                    transform: "translate(100px, 25px)", 
                      })}
                  
                            >
                              Active Out of Stock ({productsCounts.activeOutOfStock})
                            </Badge>
                          </Box>
                        </div>
                      </Flex>
    <Text
                    fw={600}
                    tt="uppercase"
                    size={"sm"}
                    sx={theme => ({
                      letterSpacing: 1,
                      color: theme.colors.brand[7],
                    })}
                  >
                    Product List
                  </Text>
                </Box>
              )}
              renderRowActions={({ row }) => (
                <Flex>
                  <Tooltip label="View Product">
                    <ActionIcon
                      sx={theme => ({ color: theme.colors.brand[7] })}
                      onClick={() => {
                        navigate(`view/?id=${row.original.id}`);
                      }}
                    >
                      <IconEye style={{ width: 20 }} />
                    </ActionIcon>
                  </Tooltip>
                  <Tooltip label="Manage Batch">
                    <ActionIcon
                      ml={10}
                      sx={theme => ({ color: theme.colors.brand[7] })}
                      onClick={() => {
                        setSelectedProduct(row.original);
                        setUserFormVisible(true);
                      }}
                    >
                      <IconPackage style={{ width: 20 }} />
                    </ActionIcon>
                  </Tooltip>

                  <Tooltip label="Edit Product">
                    <ActionIcon
                      sx={theme => ({ color: theme.colors.brand[7] })}
                      ml={10}
                      onClick={() => {
                        navigate(`edit?id=${row.original.id}`);
                      }}
                    >
                      <IconEdit style={{ width: 20 }} />
                    </ActionIcon>
                  </Tooltip>

                  <Tooltip label="Delete Product">
                    <ActionIcon
                      sx={theme => ({ color: theme.colors.red[6] })}
                      ml={10}
                      onClick={() => {
                        openDeleteConfirmation(row.original.id);
                      }}
                    >
                      <IconTrash style={{ width: 20 }} />
                    </ActionIcon>
                  </Tooltip>
                </Flex>
              )}
              initialState={{ density: "xs" }}
              columns={columns}
              enableDensityToggle={false}
              enableFullScreenToggle={isMobileScreen}
              enableColumnActions={false}
              data={productsData || []}
              enableStickyHeader
              enablePagination
              autoResetPageIndex={false}
              enableGlobalFilter={true}
              onPaginationChange={(updater) => {
                setPagination((prev) => {
                  const newPagination = typeof updater === "function" ? updater(prev) : updater;
                  return { ...prev, ...newPagination };
                });
              }}
              rowCount={productsCount}
              manualPagination
              manualFiltering
            />
          </Box>
        </Box>
      </Container>
      )}

      <Modal
        opened={userFormVisible}
        onClose={() => {
          setUserFormVisible(false);
        }}
        title={
          <Box px={10}>
            <Text fw={700}> Manage Batches </Text>
          </Box>
        }
        size={"960px"}
        centered
      >
        <BatchMaster product={selectedProduct} />
      </Modal>

      <Modal
        opened={!!selectedBatchStockDetails}
        onClose={() => setSelectedBatchStockDetails(null)}
        title={
          <Box px={10}>
            <Text fw={700}>
              {selectedBatchStockDetails?.title || "Product"} ({selectedBatchStockDetails?.batch_no || "Batch"}) - Stock Distribution Preview
            </Text>
          </Box>
        }
        size="lg"
        centered
      >
        <Box px={10} py={5}>
          <Table striped highlightOnHover withBorder withColumnBorders>
            <thead>
              <tr>
                <th style={{ padding: '10px' }}>Location</th>
                <th style={{ padding: '10px', textAlign: 'right' }}>Stock Qty</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '10px', fontWeight: 600 }}>Main Warehouse</td>
                <td style={{ padding: '10px', textAlign: 'right', fontWeight: 600 }}>
                  {selectedBatchStockDetails?.stock || 0}
                </td>
              </tr>
              {(selectedBatchStockDetails?.counter_stocks || []).map((cs, idx) => (
                <tr key={idx}>
                  <td style={{ padding: '10px' }}>{cs.counter_name}</td>
                  <td style={{ padding: '10px', textAlign: 'right' }}>{cs.stock}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th style={{ padding: '10px', color: 'darkgreen' }}>Grand Total</th>
                <th style={{ padding: '10px', textAlign: 'right', color: 'darkgreen' }}>
                  {Number(selectedBatchStockDetails?.stock || 0) + 
                    (selectedBatchStockDetails?.counter_stocks || []).reduce((acc, c) => acc + (Number(c.stock) || 0), 0)}
                </th>
              </tr>
            </tfoot>
          </Table>
        </Box>
      </Modal>
{/* {duplicateBatchesList.length > 0 && viewMode === 'unassign' && (
      <FloatingMenu
         m={5}
         right
         size={50}
         mr={60} 
         color="red" 
         onClick={() => {
             setDuplicateBatchesModal(true); 
         }}
         
         style={{ top: '400px' }} 
         
         tooltip={`Show ${duplicateBatchesList.length} Duplicate Batches`}
         >
    <IconAlertTriangle color="yellow" /> 
</FloatingMenu>
)}
      <Modal
  opened={duplicateBatchesModal}
  onClose={() => setDuplicateBatchesModal(false)}
  title={<Text fw={700}>Duplicate Unassigned Batches</Text>}
  size="xl"
  centered
>
  {duplicateBatchesIsLoading  ? (
    <Text ta="center" c="blue" p="md">Loading Duplicate Batches...</Text>
  ) : duplicateBatchesList.length === 0 ? (
    <Text ta="center" c="dimmed" p="md">No duplicate unassigned batches found.</Text>
  ) : (
    <Box mah={600} style={{ overflowY: 'auto' }}>
      <Table striped withBorder withColumnBorders verticalSpacing="sm">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Batch Code</th>
            <th>Stock</th>
            <th>Selling Price</th>
            <th>Expiry Date</th>
          </tr>
        </thead>
        <tbody>
          {duplicateBatchesList.map((batch, index) => (
            <tr key={index}>

              <td>{batch.title}</td> 
              <td>{batch.batch_no || batch.product_code}</td> 
              <td>{batch.stock}</td>
              <td>{batch.selling_price}</td>
              <td>{dayjs(batch.exp_date).format('DD/MM/YYYY')}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Box>
  )}
</Modal> */}

      {/* BARCODE PRINT MODAL */}
{/* <Modal
  opened={showBarcodeModal}
  onClose={() => setShowBarcodeModal(false)}
  title={
    <Flex justify="space-between" align="center" w="100%">
      <Text fw={600}>Batch Barcodes</Text>
      <Button color="green" onClick={handleBarcodePrint}>Print</Button>
    </Flex>
  }
  size="xl"
  fullScreen
>
  
  <div ref={barcodePrintRef} style={{ padding: 20 }}>
    {Array.from({ length: Math.ceil(barcodeData.length / 16) }).map((_, pageIdx) => {
      const pageItems = barcodeData.slice(pageIdx * 16, (pageIdx + 1) * 16);
      return (
        <div
          key={pageIdx}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)", // 4 columns x 4 rows = 16
            gap: 16,
            marginBottom: 24,
            pageBreakAfter: "always", // force page break for print
            // Optional: width control for better A4 fit
            // width: '100%',
          }}
        >
          {pageItems.map((code, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 8,
                // border: "1px solid #eee", // optional
                minHeight: 120, // ensure space for barcode + text
                pageBreakInside: "avoid"
              }}
            >
              <Barcode
                value={code}
                height={60}
                width={1.8}
                displayValue={false} // hide default text; we'll render custom text
                margin={0}
              />
              <div style={{ marginTop: 8, fontSize: 12, fontWeight: 600 }}>
                {code}
              </div>
            </div>
          ))}
        </div>
      );
    })}
  </div>
</Modal>*/}


      <div style={{ display: "none" }}>
        <PrintModal title="Products" head={head} body={body} foots={foot} ref={componentRef} />
      </div> 

      {isMobileScreen ? (
        <>
          <FloatingMenu
            m={5}
            left
            size={50}
            onClick={() => {
              setIsCsv(true);
              if (isProductCodeMode) {
                printFilter_productCodeWise();
              } else {
                printFilter();
              }
            }}
          >
            <IconDownload color="white" />
          </FloatingMenu>
          <FloatingMenu
            m={5}
            ml={60}
            left
            size={50}
            onClick={() => {
              if (isProductCodeMode) {
                printFilter_productCodeWise(false);
              } else {
                printFilter();
              }
            }}
          >
            <IconPrinter color="white" />
          </FloatingMenu>


          <FloatingMenu m={5} right size={50} mr={60} onClick={syncBatches}>
            <IconRefreshDot color="white" />
          </FloatingMenu>
          <FloatingMenu
            m={5}
            right
            size={50}
            onClick={() => {
              navigate("add");
            }}
          >
            <IconPlus color="white" />
          </FloatingMenu>

          {/* Filter Batches Floating Button */}
          <FloatingMenu
            m={5}
            right
            size={50}
            mr={60} // spacing from the first button
            onClick={() => setShowUpdateOptions(true)} // 👈 shows the container
          >
            <IconRefreshDot color="white" />
          </FloatingMenu>

          <FloatingMenu
            m={5}
            right
            size={50}
            onClick={() => {
              navigate("add");
            }}
          >
            <IconPlus color="white" />
          </FloatingMenu>
        </>
      ) : (
        <></>
      )}
    </>
  );
}